// // ResponsiveCamera.jsx 


import React from 'react';
import { PerspectiveCamera } from "@react-three/drei";
import './styles.css'; 
import './index.css'; 
import './App.css'; 

const ResponsiveCamera = () => {
  const isMobile = window.innerWidth <= 768;

  const cameraPosition = isMobile ? [0, 45, 45] : [0, 10, 10];

  return <PerspectiveCamera makeDefault position={cameraPosition} />;
}

export default ResponsiveCamera;







// import React, { useState, useEffect } from 'react';
// import { PerspectiveCamera } from "@react-three/drei";
// import './styles.css'; 
// import './index.css'; 
// import './App.css'; 

// const ResponsiveCamera = () => {
//   const [isMobilePortrait, setIsMobilePortrait] = useState(window.innerWidth <= 768 && window.innerHeight > window.innerWidth);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobilePortrait(window.innerWidth <= 768 && window.innerHeight > window.innerWidth);
//     };

//     window.addEventListener('resize', handleResize);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);

//   const cameraPosition = [0, 10, 10]; // Same position for both orientations
//   const fov = isMobilePortrait ? 75 : 50; // Zoom out in portrait by increasing FOV

//   return <PerspectiveCamera makeDefault position={cameraPosition} fov={fov} />;
// }

// export default ResponsiveCamera;











